// src/components/legal/LegalLayout.jsx

import React from 'react';
import { ArrowLeft, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { PALETTE, THEME_CLASSES } from '../../lib/theme.js'; //

export default function LegalLayout({ title, lastUpdated, children, isDark }) {
    const navigate = useNavigate();

    return (
        <div className={`min-h-screen w-full p-6 md:p-12 transition-colors duration-500 ${THEME_CLASSES.bgMain(isDark)} ${THEME_CLASSES.textPrimary(isDark)}`} style={{ fontFamily: PALETTE.font }}>
            <div className="max-w-4xl mx-auto">
                {/* Header Controls */}
                <div className="flex items-center justify-between mb-10">
                    <button
                        onClick={() => navigate(-1)}
                        className={`flex items-center space-x-2 text-sm font-medium hover:opacity-80 transition-opacity ${THEME_CLASSES.textSecondary(isDark)}`}
                    >
                        <ArrowLeft size={18} />
                        <span>Back</span>
                    </button>

                    <button
                        className={`flex items-center space-x-2 text-sm font-medium px-4 py-2 rounded-lg border transition-all ${THEME_CLASSES.bgCard(isDark)} ${THEME_CLASSES.borderSubtle(isDark)} hover:border-gray-400`}
                    >
                        <Download size={16} />
                        <span>Download PDF</span>
                    </button>
                </div>

                {/* Document Content */}
                <div className={`backdrop-blur-2xl rounded-[32px] p-8 md:p-12 shadow-xl border ${THEME_CLASSES.bgCard(isDark)} ${THEME_CLASSES.borderSubtle(isDark)}`}>
                    <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2">{title}</h1>
                    <p className={`text-sm mb-10 ${THEME_CLASSES.textSecondary(isDark)}`}>
                        Last Updated: {lastUpdated}
                    </p>

                    <div className="prose prose-blue max-w-none dark:prose-invert">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}